/**!
 * jQuery Checkboxes
 *
 * Allows us to create our own button style checkboxes by hiding the actual checkbox inputs and
 * using the label as a container for custom html
 *
 * Depends:
 *  jQuery obj
 *
 *
 * Description:
 *
 *  For click events we rely upon the special relationship between a
 *  checkbox type input and it's label -
 *
 *  when the label's "for" attribute matches the inputs "id" attribute, clicking on the label
 *  will trigger the click event for the input, even if the input is hidden.
 *
 *
 * Expected Markup:
 *
 * <ul id="some_ul_elem_id" class="checkbox_list">
 *     <li>
 *         <input type="checkbox" name="sample_checkbox" id="sample_checkbox_1" value="1" />
 *         <label for="sample_checkbox_1">
 *             put your custom html in here
 *        	  <div class="checkbox"></div>
 *         </label>
 *         <p>other optional text and html can go here too...</p>
 *     </li>
 *     <li>
 *         <input type="checkbox" name="sample_checkbox" id="sample_checkbox_2" value="2" />
 *         <label for="sample_checkbox_2">html in here
 *             <div class="checkbox"></div>
 *         </label>
 *     </li>
 *     <li>
 *         <input type="checkbox" name="sample_checkbox" id="sample_checkbox_3" value="3" />
 *         <label for="sample_checkbox_3">html in here
 *             <div class="checkbox"></div>
 *         </label>
 *     </li>
 * </ul>
 *
 * Create an instance like this:
 *
 * $('#some_ul_elem_id').checkboxes();
 *
 *
 **/



(function( $ ) {

//    console.log("registering checkboxes plugin");

    $.fn.checkboxes = function(options) {

        var settings = $.extend( {
            // optional callback for when a checkbox gets toggled
            'change': function() {}
          }, options);

        return this.each(function() {

//            console.log("creating checkboxes instance!");

            var $this = $(this);
            var $lis = $this.children('li');
            var $checkboxes = $lis.children('input[type="checkbox"]');

            // hide checkbox inputs
            // the checkbox inputs must stay "visible" for <= IE8 or else they will not post,
            // so just move them way off screen
            $checkboxes.css({
                'display': 'block',
                'position' : 'absolute',
                'left' : '-10000px'
            }).attr('tabindex', "-1"); // and take them out of tabindex order

            // give all of the li's a tab index
            $lis.attr('tabindex', "0").removeClass("selected");

            // add selected class to the li's that have their checkbox checked
            $checkboxes.filter('input[type="checkbox"]:checked').parent('li').addClass("selected");

            // change event on the checkbox input itself
            // which is also triggered by clicking on it's label
            // note: the label's "for" attribute must match its input's id

            // dirty hack for IE8 and below - use propertychange instead of change, since change event does not fire
            // when simulating a click on a label.
            // TODO: replace this with the regular change event when we sunset support for IE8
            var lteIE8 = ( document.all && !document.addEventListener );
            var change_event = ( lteIE8 ) ? "propertychange" : "change";

            $checkboxes.on(change_event, function(e) {
//                console.log("change event", e);

                if ( $(this).is(":checked") ) {
//                    console.log("this is checked!");
                    $(this).parent('li').addClass("selected").focus();
                }
                else {
//                    console.log("this is NOT checked!");
                    $(this).parent('li').removeClass("selected").focus();
                }

                // fire callback, with param for the affected checkbox element
                settings.change( this );
            });

            $lis.keydown( function(event) {
//                console.log("got a keydown event!");
//                console.log("event keycode", event.keyCode);

                switch( event.keyCode ) {
                    // spacebar will toggle the checked state of the currently focused checkbox
                    // by triggering a click event on the label
                    case 32:
                        event.preventDefault(); // stop spacebar from scrolling the page...
                        $(this).children('label').trigger("click");
                        break;
                }
            });


        });
    };

})(jQuery);